"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 *  Gemeinsame Fehlerbehandlung der Produkt-Konfiguratoren ( confi-*.js ).
 *
 *  Laravel antwortet bei ungültigen Eingaben mit 422 und
 *  { message , errors : { 'frame.roofLength' : [ '…' ] } } .
 *  Die Schlüssel sind Punkt-Pfade in den Request-Body
 *  ( siehe steda-shopify-app : app/Http/Requests/Configurator/* ).
 *
 *  Texte kommen aus #Confi-Error-Strings ( Product-Section.liquid ).
 */
(function (root) {
  var Invalid_Attribute = 'data-confi-invalid';
  var Default_Strings = {
    invalid_title: 'Konfiguration so nicht möglich!',
    invalid_text: 'Bitte prüfe deine Konfiguration.',
    server_title: 'Preis konnte nicht berechnet werden.',
    server_text: 'Bitte versuche es in ein paar Minuten noch einmal.',
    network_title: 'Keine Verbindung zum Server.',
    network_text: 'Bitte prüfe deine Internetverbindung und versuche es erneut.'
  };
  var strings = null;
  var texts = function texts() {
    if (strings !== null) {
      return strings;
    }
    strings = Object.assign({}, Default_Strings);
    var node = typeof document !== 'undefined' ? document.getElementById('Confi-Error-Strings') : null;
    if (node !== null) {
      try {
        var parsed = JSON.parse(node.textContent);
        for (var key in parsed) {
          if (typeof parsed[key] === 'string' && parsed[key] !== '') {
            strings[key] = parsed[key];
          }
        }
      } catch (error) {
        console.error('Confi-Error-Strings', error);
      }
    }
    return strings;
  };

  /**
   *  Liest eine fehlgeschlagene Antwort ( !response.ok ) aus.
   *  @returns {{ status : number , message : string , errors : Object<string,string[]> }}
   */
  var read = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(response) {
      var result, data, key, list, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            result = {
              status: response.status,
              message: '',
              errors: {}
            };
            data = null;
            _context.p = 1;
            _context.n = 2;
            return response.json();
          case 2:
            data = _context.v;
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            return _context.a(2, result);
          case 4:
            if (!(data === null || _typeof(data) !== 'object')) {
              _context.n = 5;
              break;
            }
            return _context.a(2, result);
          case 5:
            if (typeof data.message === 'string') {
              result.message = data.message;
            }
            if (data.errors !== null && _typeof(data.errors) === 'object') {
              for (key in data.errors) {
                list = Array.isArray(data.errors[key]) ? data.errors[key] : [data.errors[key]];
                result.errors[key] = list.filter(function (message) {
                  return typeof message === 'string' && message !== '';
                });
              }
            }
            return _context.a(2, result);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function read(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  /**
   *  fetch() selbst ist fehlgeschlagen ( offline , CORS , DNS ).
   */
  var network = function network() {
    return {
      status: 0,
      message: '',
      errors: {}
    };
  };

  /**
   *  Alle Meldungen ohne Doppelte , in der Reihenfolge des Backends.
   */
  var messages = function messages(result) {
    var list = [];
    for (var key in result.errors) {
      var _iterator = _createForOfIteratorHelper(result.errors[key]),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var message = _step.value;
          if (list.indexOf(message) === -1) {
            list.push(message);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    if (list.length === 0 && result.status === 422 && result.message !== '') {
      list.push(result.message);
    }
    return list;
  };

  /**
   *  Findet zu einem Fehlerschlüssel den passendsten Eintrag in `fields`.
   *  'leftWall.frameColor' trifft 'leftWall.frameColor' vor 'leftWall'.
   *  Werte dürfen Funktionen sein ( z. B. Sondermaß statt Auswahlliste ).
   */
  var fieldFor = function fieldFor(key, fields) {
    var match = null;
    var matchLength = -1;
    for (var path in fields) {
      if ((key === path || key.indexOf(path + '.') === 0) && path.length > matchLength) {
        match = fields[path];
        matchLength = path.length;
      }
    }
    if (typeof match === 'function') {
      match = match();
    }
    return match || null;
  };
  var titleFor = function titleFor(result) {
    var text = texts();
    if (result.status === 0) {
      return text.network_title;
    }
    if (result.status === 422) {
      return text.invalid_title;
    }
    return text.server_title;
  };
  var fallbackFor = function fallbackFor(result) {
    var text = texts();
    if (result.status === 0) {
      return text.network_text;
    }
    if (result.status === 422) {
      return text.invalid_text;
    }
    return text.server_text;
  };
  var wrapperOf = function wrapperOf(field) {
    return field.closest('.input-field, .bonsai-selector, .bonsai-checkBox') || field;
  };

  /**
   *  Entfernt alle Markierungen aus show() innerhalb von `scope`.
   */
  var clear = function clear() {
    var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    var _iterator2 = _createForOfIteratorHelper(scope.querySelectorAll('[' + Invalid_Attribute + ']')),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var field = _step2.value;
        field.removeAttribute(Invalid_Attribute);
        field.removeAttribute('aria-invalid');
        var describedBy = field.dataset.confiDescribedBy;
        if (describedBy !== undefined) {
          if (describedBy === '') {
            field.removeAttribute('aria-describedby');
          } else {
            field.setAttribute('aria-describedby', describedBy);
          }
          delete field.dataset.confiDescribedBy;
        }
        wrapperOf(field).classList.remove('is-invalid');
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  };
  var markInvalid = function markInvalid(field, describedById) {
    if (field.hasAttribute(Invalid_Attribute)) {
      return;
    }
    field.setAttribute(Invalid_Attribute, '');
    field.setAttribute('aria-invalid', 'true');
    if (describedById) {
      var describedBy = field.getAttribute('aria-describedby') || '';
      field.dataset.confiDescribedBy = describedBy;
      field.setAttribute('aria-describedby', (describedBy + ' ' + describedById).trim());
    }
    wrapperOf(field).classList.add('is-invalid');
  };

  /**
   *  Zeigt einen Fehler an.
   *
   *  @param result   aus read() oder network()
   *  @param options.title    Element für die Überschrift
   *  @param options.text     Element für die Meldungen ( Liste bei mehreren )
   *  @param options.fields   { 'frame.roofLength' : Element | () => Element }
   *  @param options.scope    Bereich für clear() , Standard : document
   *  @param options.container    wird eingeblendet ( snippets/confi-api-error.liquid )
   *  @returns string[]       die angezeigten Meldungen
   */
  var show = function show(result) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var list = messages(result);
    clear(options.scope || document);

    // Erst einblenden , dann füllen : sonst kündigt die Live-Region nichts an
    if (options.container) {
      options.container.hidden = false;
    }
    if (options.title) {
      options.title.textContent = titleFor(result);
    }
    if (options.text) {
      options.text.textContent = '';
      if (list.length > 1) {
        var ul = document.createElement('ul');
        ul.className = 'confi-error-list';
        var _iterator3 = _createForOfIteratorHelper(list),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var message = _step3.value;
            var li = document.createElement('li');
            li.textContent = message;
            ul.appendChild(li);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        options.text.appendChild(ul);
      } else {
        options.text.textContent = list.length === 1 ? list[0] : fallbackFor(result);
      }
    }
    if (options.fields) {
      var describedById = options.text && options.text.id ? options.text.id : '';
      for (var key in result.errors) {
        var field = fieldFor(key, options.fields);
        if (field !== null) {
          markInvalid(field, describedById);
        }
      }
    }
    return list.length > 0 ? list : [fallbackFor(result)];
  };

  /**
   *  Blendet einen Container aus show() wieder aus und entfernt die Markierungen.
   */
  var hide = function hide(container) {
    var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
    if (container) {
      container.hidden = true;
    }
    clear(scope);
  };

  /**
   *  `Accept : application/json` ist nötig , sonst antwortet Laravel bei
   *  Validierungsfehlern mit einem Redirect statt mit 422 und JSON.
   */
  var headers = function headers() {
    var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var list = {
      'Accept': 'application/json',
      'Accept-Language': typeof Shopify !== 'undefined' ? Shopify.locale : ''
    };
    if (json) {
      list['Content-Type'] = 'application/json';
    }
    return list;
  };
  var ConfiErrors = {
    read: read,
    network: network,
    messages: messages,
    fieldFor: fieldFor,
    show: show,
    hide: hide,
    clear: clear,
    headers: headers,
    texts: texts,
    titleFor: titleFor,
    fallbackFor: fallbackFor
  };
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = ConfiErrors;
  }
  if (root) {
    root.ConfiErrors = ConfiErrors;
  }
})(typeof window !== 'undefined' ? window : null);